<template>
  <component :is="resolveLayout">
    <router-view></router-view>
  </component>
</template>

<script>
import { computed, onMounted } from '@vue/composition-api'
import { useRouter } from '@/utils'
import LayoutBlank from '@/layouts/Blank.vue'
import LayoutContent from '@/layouts/Content.vue'

export default {
  components: {
    LayoutBlank,
    LayoutContent,
  },
  setup() {
    const { route } = useRouter()

    const resolveLayout = computed(() => {
      if (route.value.name === null) return null
      if (route.value.meta.layout === 'blank') return 'layout-blank'
      return 'layout-content'
    })

    onMounted(() => {
      const size = localStorage.getItem('tableFontSize') === 'large' ? '1.0625rem' : '0.875rem'
      document.documentElement.style.setProperty('--table-font-size', size)
    })

    return { resolveLayout }
  },
}
</script>

<style>
.v-text-field input,
.v-select__selection--comma {
  color: rgba(0, 0, 0, 0.8) !important;
}

@media (max-width: 959px) {
  .v-data-table td,
  .v-data-table th,
  .v-data-table .v-data-table__mobile-row__cell,
  .v-data-table .v-data-table__mobile-row__header {
    font-size: var(--table-font-size, 0.875rem) !important;
  }
  .mobile-black-text .v-data-table__mobile-row__header,
  .mobile-black-text .v-data-table__mobile-row__cell {
    color: rgba(0, 0, 0, 0.8) !important;
    font-size: 1rem !important;
  }
}
</style>
